module.exports = __webpack_public_path__ + "img/620.9400b106.png";